import { gql } from "graphql-request"

export const CreateAnswer = gql`
  mutation CreateAnswer($auditId: Int!, $questionId: Int!, $optionId: Int!, $attachmentUrls: [String!]) {
    createAnswer(auditId: $auditId, questionId: $questionId, optionId: $optionId, attachmentUrls: $attachmentUrls) {
      id
    }
  }
`
